export const actions = {
  async sendContact(...args) {
    const params = args[1];
    try {
      const { data } = await this.$axios.post('/contact/', params);
      if (data.error) {
        return {
          error: true,
          message: 'There was an error trying to submit form. Please try again later.'
        };
      }
      return {
        error: false,
        message: 'Submitted successfully'
      };
    } catch (e) {
      return {
        error: true,
        message: 'There was an error trying to submit form. Please try again later.'
      };
    }
  },
  changeColorIntercom(store, experience) {
    if (process.browser) {
      const changedColor = '#3f80f1';
      window.Intercom
        ? window.Intercom('update', {
            background_color: changedColor,
            action_color: changedColor,
            Experience: experience
          })
        : null;
    }
  },
  updateUserDataIntercom({ state, getters }) {
    if (process.browser) {
      if (state.auth.user) {
        window.Intercom
          ? window.Intercom('update', {
              name: state.auth.user.userName,
              email: state.auth.user.email,
              avatar: { type: 'avatar', image_url: state.auth.user.userAvatar },
              Experience: state.experience.userExperience
            })
          : null;
      } else {
        const expColor = getters['experience/getExperienceColor'];
        window.Intercom ? window.Intercom('shutdown') : null;
        window.Intercom
          ? window.Intercom('boot', {
              background_color: expColor,
              action_color: expColor,
              Experience: state.experience.userExperience
            })
          : null;
      }
    }
  }
};
